<mat-toolbar class="topbar cardWithShadow">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  <button
    mat-icon-button
    (click)="toggleCollapsed.emit()"
    *ngIf="showToggle"
    class="d-flex justify-content-center"
  >
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>

  <!-- Mobile Menu -->
  <div style="float: right">
    <button
      mat-icon-button
      (click)="openCloseMobile()"
      *ngIf="!showToggle"
      class="d-flex justify-content-center"
    >
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
  </div>

    <!-- Select de Empresa para vista Cliente -->

  <div *ngIf="isClient=='True'" class="custom-select-container">
    <select class="custom-select" name="miSelect" [(ngModel)]="selectedCompany" (ngModelChange)="onCompanyChange($event)">
      <option *ngFor="let company of companiesAssociedwithdv" [value]="company">
        {{ company }}
      </option>
    </select>
  </div>

  <span class="flex-1-auto"></span>

  <div *ngIf="isMobile == true" style="float: right; padding-right: 6px;">
    <img src="/assets/images/logos/dark-logo.png" width="160" />
  </div>

  <div *ngIf="showButtons">
    <button
      mat-icon-button
      class="d-flex justify-content-center"
      (click)="openAndCloseNotify()"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
    >
      <i-tabler *ngIf="!notifySucceed" name="loader" class="icon-40 d-flex"></i-tabler>
      <i-tabler *ngIf="notifySucceed" name="bell" class="icon-40 d-flex" matBadgePosition="before" matBadge="{{totalNotifications}}" [matBadgeHidden]="totalNotifications === 0"></i-tabler>
    </button>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isOpen"
    >
      <app-alert-notification
        (contentSucceed)="updateIconNotify()"
        (closeNotifications)="closeNotify()"
        (moreNotify)="loadMoreNotifications()"
        [notificationsRecived]="alerts"
        [notificationsRecivedCountPending]="alertPendingCount"
      ></app-alert-notification>
    </ng-template>
  </div>

</mat-toolbar>